import { createTheme } from '@mui/material/styles';
import theme from 'src/themes/baseTheme';

const pariTheme = createTheme(theme, {
  palette: {
    primary: {
      main: '#A483FF',
      contrastText: '#FFFFED',
      light: '#C8B4FF',
      dark: '#58468A',
    },
    secondary: {
      main: '#7ACCCA',
      contrastText: '#FFFFFF',
      light: '#96FAF8',
      dark: '#345756',
    },
    error: {
      main: '#FF4B20',
      contrastText: '#FFFFFF',
      light: '#DB431D',
      dark: '#611D0D',
    },
    info: {
      main: '#759AFF',
      contrastText: '#fff',
      light: '#8799CC',
      dark: '#1C2233',
    },
    success: {
      main: 'rgb(51, 208, 103)',
      light: '#99E8B3',
      dark: '#1E9A43',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
  },
  shape: {
    borderRadius: 5,
  },
});

export default pariTheme;
